var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{attrs:{"align":"center"}},[_c('b-col',[_c('b',[_vm._v(_vm._s(_vm.description))])])],1),_c('b-img',{attrs:{"thumbnail":"","fluid":"","src":_vm.ams_data.attributes['image-url'],"alt":_vm.description}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }